import React, { useEffect } from "react";
import styled from "@mui/system/styled";
import { PatternFormat } from "react-number-format";
import { useCallCenterForm } from "../hooks/useCallCenterForm";

import TextField from "@mui/material/TextField";

const TextInput = styled(TextField)(() => ({
  padding: "4px",
}));

const CustomFormatCardExpiration = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <PatternFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      format={"##/##"}
    />
  );
});

const CardExpiration = () => {
  const { errors, formValues, handleInputChange, handleInputFocus } =
    useCallCenterForm();

  useEffect(() => {}, [formValues]);

  const handleErrorText = () => {
    if (!errors?.card_expiration) {
      return null;
    }

    return errors?.card_expiration;
  };

  return (
    <TextInput
      sx={{ flex: 1 }}
      name="card_expiration"
      label="Card Expiration"
      value={formValues?.card_expiration}
      InputProps={{
        inputComponent: CustomFormatCardExpiration,
      }}
      inputProps={{
        inputMode: "numeric",
      }}
      error={!!errors?.card_expiration}
      onChange={handleInputChange}
      onFocus={handleInputFocus}
      helperText={handleErrorText()}
    />
  );
};

export default CardExpiration;
